import { useState } from 'react';
import {
  FileText, 
  Download, 
  Calendar, 
  Filter,
  BarChart, 
  PieChart, 
  LineChart, 
  Table,
  Mail, 
  Printer, 
  Share2, 
  MoreVertical,
  Phone,        // ← AJOUTÉ
  DollarSign,   // ← AJOUTÉ
  Activity      // ← AJOUTÉ
} from 'lucide-react';

export default function ReportsPage() {
  const [selectedReport, setSelectedReport] = useState('leads');

  const reports = [
    { id: 'leads', name: 'Rapport leads', icon: FileText, date: '18/02/2026' },
    { id: 'calls', name: 'Rapport appels', icon: Phone, date: '17/02/2026' },
    { id: 'deals', name: 'Rapport deals', icon: DollarSign, date: '16/02/2026' },
    { id: 'activity', name: 'Rapport activité', icon: Activity, date: '15/02/2026' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          Rapports
        </h1>
        <div className="flex gap-2">
          <button className="px-4 py-2 bg-gray-900 rounded-lg border border-gray-800 text-gray-300 hover:text-white flex items-center gap-2">
            <Calendar size={18} />
            Février 2026
          </button>
          <button className="px-4 py-2 bg-cyan-600 rounded-lg text-white flex items-center gap-2">
            <Download size={18} />
            Exporter
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Liste des rapports */}
        <div className="lg:col-span-1 bg-gray-900 rounded-xl border border-gray-800 p-4">
          <h3 className="text-white font-medium mb-3">Rapports disponibles</h3>
          <div className="space-y-2">
            {reports.map(report => (
              <button
                key={report.id}
                onClick={() => setSelectedReport(report.id)}
                className={`w-full flex items-center gap-3 p-3 rounded-lg transition ${
                  selectedReport === report.id ? 'bg-cyan-600/20 text-cyan-400' : 'hover:bg-gray-800 text-gray-300'
                }`}
              >
                <report.icon size={18} />
                <div className="flex-1 text-left">
                  <p className="text-sm font-medium">{report.name}</p>
                  <p className="text-xs text-gray-500">{report.date}</p>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Aperçu du rapport */}
        <div className="lg:col-span-3 bg-gray-900 rounded-xl border border-gray-800 p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Aperçu du rapport</h2>
          
          <div className="space-y-4">
            <div className="grid grid-cols-3 gap-4 p-4 bg-gray-800/30 rounded-lg">
              <div>
                <p className="text-gray-400 text-sm">Total leads</p>
                <p className="text-2xl font-bold text-white">581</p>
              </div>
              <div>
                <p className="text-gray-400 text-sm">Taux conversion</p>
                <p className="text-2xl font-bold text-green-400">23%</p>
              </div>
              <div>
                <p className="text-gray-400 text-sm">Valeur moyenne</p>
                <p className="text-2xl font-bold text-white">1,250€</p>
              </div>
            </div>

            <table className="w-full">
              <thead className="bg-gray-800/50">
                <tr>
                  <th className="p-3 text-left text-gray-300">Nom</th>
                  <th className="p-3 text-left text-gray-300">Email</th>
                  <th className="p-3 text-left text-gray-300">Statut</th>
                  <th className="p-3 text-left text-gray-300">Date</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800">
                {[1,2,3,4,5].map(i => (
                  <tr key={i} className="hover:bg-gray-800/30">
                    <td className="p-3 text-white">Lead {i}</td>
                    <td className="p-3 text-gray-300">lead{i}@email.com</td>
                    <td className="p-3">
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">Qualifié</span>
                    </td>
                    <td className="p-3 text-gray-300">18/02/2026</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}